import React, { useEffect } from 'react'
import { Typography } from '@mui/material'
import { UseImage, GenericContainerConfirm } from '../../components'
import { getReplaceTitle } from '../../utils'

import packageJson from "../../../package.json";
import RegistroExitosoImg from '../../assets/RegistroExitoso.jpg'

export default function ConfirmComponent(props) {

  useEffect(() => {//ComponentDidUpdate
    getReplaceTitle("Confirmación")
  }, [])

  return (<>
    <UseImage
      src={RegistroExitosoImg}
      width='100%'
    />
    <GenericContainerConfirm sx={{ justifyContent: 'center !important' }}>
      <Typography variant="h6" gutterBottom sx={{width: "100%", textAlign: "center"}} >Registro exitoso</Typography>
      <Typography variant="subtitle1" gutterBottom >Para acceder es necesario que actives tu cuenta desde el link que ha sido enviado a tu correo electrónico.</Typography>
      <Typography variant="subtitle1" gutterBottom >{packageJson.copyright}</Typography>
    </GenericContainerConfirm >
  </>)
}